import connector from 'api/http';
import { CreditCardDetails } from 'scenes/common/types';
import config from 'shared/config';

import { marshalRequest } from './marshaller';
import { WestpacResponse } from './types';

const westpacApi = (baseUrl: string = config.baseUrls.WESTPAC_BASE_URL) => {
  const server = connector(baseUrl);

  return {
    getSingleUseToken: (
      supplierBusinessCode: string,
      token: string,
      creditCardDetails: CreditCardDetails
    ): Promise<WestpacResponse> =>
      Promise.resolve()
        .then(() => marshalRequest(supplierBusinessCode, creditCardDetails))
        .then((request) =>
          server.post('/single-use-tokens', request, {
            username: token,
            password: '',
          })
        ),
  };
};

export default westpacApi;
